import { useRef, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInViewport } from "react-in-viewport";

const MovingImage = ({ yPosAnim, image, imageMob, className }) => {
  const myRef = useRef();
  const animation = useAnimation();

  const { inViewport, enterCount, leaveCount } = useInViewport(
    myRef,
    {},
    {
      onEnterViewport: () => {
        // console.log("entered viewport");
      },
    },
    { disconnectOnLeave: true }
  );

  useEffect(() => {
    if (inViewport) {
      animation.start("visible");
    } else {
      animation.start("hidden");
    }
  }, [inViewport]);

  const variants = {
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 1 },
    },
    hidden: {
      opacity: 0,
      scale: 0.8,
    },
  };

  return (
    <motion.picture
      className={className}
      style={{
        y: yPosAnim,
      }}
      animate={animation}
      initial="hidden"
      variants={variants}
      ref={myRef}
    >
      <source srcSet={imageMob?.mediaItemUrl} media="(max-width: 850px)" />
      <img src={image?.mediaItemUrl} />
    </motion.picture>
  );
};

export default MovingImage;
